<template>
  <v-container 
    v-if="!$apollo.loading && invoice"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      v-if="invoice != undefined"
      justify-center
      wrap
    >
      <v-flex
        md8
        xs12
        mb-10
      >
        <v-card>
          <v-layout
            wrap
            style="padding:20px"
          >
            <v-flex md1>
              <v-btn
                icon
                text
                small
                @click="$router.push('/invoices')"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-flex>
            <v-flex
              md3
              xs12
            >
              <v-img
                v-if="invoice.payee_logo"
                :src="invoice.payee_logo"
                :lazy-src="invoice.payee_logo"
                max-height="100"
                contain
              />
            </v-flex>
            <v-flex
              md7
              xs12
              text-md-right
              text-sm-center
              mt-5
            >
              {{ invoice.payee }}
            </v-flex>

            <v-flex
              md8
              xs12
              mt-11
            >
              <b style="font-size:20px;">{{ $t('invoices.inoviceNumber') }}{{ invoice.id }}
              </b><br><br>
              <p>
                {{ $t('invoices.for') }}<br>
                {{ invoice.payer }}
              </p>
              <p v-if="invoice.status == 'unpaid'">
                {{ $t('invoices.due') }}: 
                <b>{{ invoice.due_date | moment('ll') }}</b>
              </p>
            </v-flex>
            <v-flex
              md4
              xs12
              mt-10
            >
              <b 
                :class="colorStatus(invoice.status)"
              >
                {{ $t('invoices.'+invoice.status) }} 
              </b>
              <small v-if="invoice.status == 'paid'">
                <br>
                <b>{{ invoice.date_paid | moment('L') }}</b>
              </small>
              <div
                v-if="invoice.status == 'unpaid'"
                style="margin-top:13px;"
              >
                <div>
                  <v-btn
                    type="submit"
                    class="primary"
                    @click="payInvoiceDialog = true"
                  >
                    {{ $t('invoices.pay') }}
                  </v-btn> 
                </div>
              </div>
            </v-flex>
            <v-flex
              md12
              xs12
              mt-10
              style="margin-bottom:100px;"
            >
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t('invoices.service') }}
                    </th>
                    <th class="text-left">
                      {{ $t('invoices.price') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in invoice.items"
                    :key="item.id"
                  >
                    <td>{{ item.subject }}</td>
                    <td>{{ item.amount }} {{ item.currency }}</td>
                  </tr>
                  <tr style="height:100px;">
                    <td valign="bottom">
                      {{ $t('invoices.subtotal') }}
                    </td>
                    <td valign="bottom">
                      {{ _.sum(_.map(invoice.items, 'amount')).toFixed(6) }} {{ invoice.currency }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('invoices.taxes') }}</td>
                    <td>{{ invoice.taxes }} {{ invoice.currency }}</td>
                  </tr>
                  <tr v-if="invoice.penalty > 0">
                    <td>{{ $t('invoices.lateFee') }}</td>
                    <td>{{ invoice.penalty }} {{ invoice.currency }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('invoices.fees') }}</td>
                    <td>{{ invoice.fees }} {{ invoice.currency }}</td>
                  </tr>
                  <tr style="height:40px;">
                    <td
                      style="font-size:16px;"
                      valign="bottom"
                    >
                      <b>{{ $t('invoices.total') }}</b>
                    </td>
                    <td
                      style="font-size:16px;"
                      valign="bottom"
                    >
                      <b>{{ invoice.total }} {{ invoice.currency }}</b>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-flex>     
            <v-flex 
              v-if="invoice.txn_id"
              xs12
              ml-3
            >
              <small>{{ $t('invoices.txnId') }} <br>
                {{ invoice.txn_id }} 
              </small> 
            </v-flex>    
          </v-layout>
        </v-card>       
      </v-flex>
    </v-layout>
    <pay-invoice-dialog
      :show-dialog="payInvoiceDialog"
      :invoice="invoice"
      @closePayInvoiceDialog="closePayInvoiceDialog"
    />
  </v-container>
</template>

<script>

import INVOICE_QUERY from '@/graphql/queries/Invoice.gql';

import PayInvoiceDialog from "@/views/Invoices/PayInvoiceDialog.vue";

export default {
  name: 'InvoiceView',
  components: {
    PayInvoiceDialog
  },
  data: () => ({
    payInvoiceDialog: false,
    loading: false,
    invoice: null,
  }),
  methods: {
    closePayInvoiceDialog(refresh) {
      this.payInvoiceDialog = false
      if (refresh) {
          this.$apollo.queries.invoice.refresh();
      }
    }
  },
  apollo: {
    invoice: {
      query: INVOICE_QUERY,
      variables() {
        return {
           id: this.$route.params.id
        }
      },
    }
  },
}
</script>



<style lang="scss" >
  
</style>
